// Footer.js
import React from 'react';
import { Nav, Row, Col } from 'react-bootstrap';

const getCurrentYear = () => {
  return new Date().getFullYear();
};

function Footer() {
  return (
    <footer className="mx-4 mb-2 text-muted">
      <Row className="align-items-center">
        <Col xs={12} md={6} className="text-center text-md-start mb-2 mb-md-0">
          <div className="mb-0">
            Desarrollado por
            <small className='text-decoration-none text-muted fw-bold'><a href="https://tubisnez.netlify.app/" target="_blank" rel="noopener noreferrer" className='text-decoration-none text-danger'> TuBisnez</a> &copy; 2024 - {getCurrentYear()}</small>
          </div>
        </Col>
      </Row>
    </footer>
  );
}

export default Footer;
